import { Card } from "../../components/ui/card";
import { useProducts } from "../../hooks";
import Product from "./product/Product";

const ManageProductO = () => {
  const {
    products,
    productsLoading,
    productsError,
    productsPagination,
    productsSearch,
    setProductsSearch,
    productsPage,
    setProductsPage,
    productsPageSize,
    setProductsPageSize,
    createProduct,
    updateProduct,
    productTypes,
    productCategories,
    createProductType,
    createProductCategory,
  } = useProducts();

  return (
    <div className="flex flex-col gap-4 sm:gap-6">
      <Card className="bg-white border border-gray-200 px-3 sm:px-4 lg:px-6 py-3 sm:py-4 shadow-sm">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900">
              Product Management
            </h2>
            <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
              Manage your product inventory
            </p>
          </div>
        </div>
      </Card>

      <Product
        products={products}
        types={productTypes}
        categories={productCategories}
        loading={productsLoading}
        error={productsError}
        pagination={productsPagination}
        searchTerm={productsSearch}
        onSearchChange={setProductsSearch}
        currentPage={productsPage}
        onPageChange={setProductsPage}
        pageSize={productsPageSize}
        onPageSizeChange={setProductsPageSize}
        onCreate={createProduct}
        onUpdateProduct={updateProduct}
        onCreateType={createProductType}
        onCreateCategory={createProductCategory}
      />
    </div>
  );
};

export default ManageProductO;
